import { FaBrain, FaLock, FaRobot } from "react-icons/fa";
import images from "./images";

const About = {
    sub: "About Us",
    heading: "Empowering Innovation with AI & IT",
    description: "Welcome to AIByte, your trusted partner in AI and IT solutions. We are dedicated to helping businesses harness the power of technology to drive growth, improve efficiency, and stay ahead in a competitive landscape.",
    points: [
        { icon: <FaBrain />, title: "Intelligent Solution", content: "Advanced AI tools to transform your business processes." },
        { icon: <FaLock />, title: "Reliable Security", content: "Robust IT security measures to safeguard your data." }
    ],
    image: {
        src: images.about,
        alt: "About Image",
        designText: "Innovating with AI and IT Solutions.",
        experience: {
            years: "10+ years",
            title: "Industry Leader",
            icon: <FaRobot />
        }
    },
    button: {
        text: "Learn More",
        link: "About-us"
    }
};

export default About;